import SchoolField from './SchoolField'

export default SchoolField
